import React from "react";

const MoreButton = () => {
  return <div className="arrow-right" aria-label="MORE"></div>;
};

export default MoreButton;
